import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-rewards-request-confirm',
  templateUrl: './rewards-request-confirm.component.html',
  styleUrls: ['./rewards-request-confirm.component.scss'],
})
export class RewardsRequestConfirmComponent  implements OnInit {
  @Output() onClickCancel: EventEmitter<any> = new EventEmitter();
  @Output() onClickContinue: EventEmitter<any> = new EventEmitter();
  @Input() confirmationMsg:string = "";
  @Input() confirmationMsg2:string = "DO YOU WANT TO CONTINUE WITH THE REDEMPTION?";
  constructor() { }

  ngOnInit() {}

  clickCancel(){
    this.onClickCancel.emit()
  }

  clickContinue(){
    this.onClickContinue.emit()
  }
}
